import 'sortable-tablesort/sortable.min.js'

export default class WhmcsServersConfigTable {
  constructor () {
    if (!document.querySelector('.whmcs-servers-table')) return

    this.checkboxes = document.querySelectorAll('.whmcs-servers-filter__input')
    this.rows = document.querySelectorAll('table tbody tr')

    this.events()
  }

  events () {
    this.checkboxes?.forEach((checkbox) => {
      checkbox.addEventListener('change', this.filterTable.bind(this))
    })
  }

  filterTable () {
    // Get the selected values from each checkbox
    const selectedCpu = this.getSelectedValues('cpu');
    const selectedRam = this.getSelectedValues('ram');
    const selectedStorage = this.getSelectedValues('storage');

    // Check if at least one storage option is selected
    const isStorageSelected = selectedStorage.includes('SSD') || selectedStorage.includes('HDD');

    // Loop through each table row
    this.rows.forEach((row) => {
      const cpu = row.getAttribute('data-cpu');
      const ram = row.getAttribute('data-ram');
      const storage = row.getAttribute('data-storage');

      // Check if the row matches the selected filters
      const cpuMatch = selectedCpu.length === 0 || selectedCpu.includes(cpu);
      const ramMatch = selectedRam.length === 0 || selectedRam.includes(ram);
      const storageMatch = isStorageSelected
        ? selectedStorage.some(option => storage.includes(option))
        : true;

      // Show/hide the row based on the filter results
      const showRow = cpuMatch && ramMatch && storageMatch;
      row.style.display = showRow ? 'table-row' : 'none';
    });

  }

  getSelectedValues (name) {
    const selectedValues = []
    const checkboxes = document.querySelectorAll(
      `input[name="${name}"]:checked`)
    checkboxes.forEach((checkbox) => {
      selectedValues.push(checkbox.value)
    })
    return selectedValues
  }
}